<template>
  <svg
    @click="$emit('click', $event)"
    :width="width"
    class="h-auto"
    viewBox="0 0 50 50"
    preserveAspectRatio="xMidYMid meet"
  >
    <g :fill="fill">
      <slot />
    </g>
  </svg>
</template>

<script>
import { colors } from "@utils/tailwind";

export default {
  name: "CoreIcon",

  props: {
    color: {
      type: String,
      default: "white"
    },
    width: {
      type: Number,
      default: 20
    }
  },

  computed: {
    fill() {
      return colors[this.color];
    }
  }
};
</script>
